import { useInView } from '@cian/valuation-utils-component';
import * as React from 'react';

enum ELazyLoadStatus {
  Pending = 'pending',
  Loaded = 'loaded',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type TParams = any;

export interface ILazyLoadProps {
  offset?: number;
  onLoad: () => Promise<TParams>;
  renderLoaded: (params: TParams) => JSX.Element;
  renderEmpty: () => JSX.Element;
}

export const LazyLoad: React.FC<ILazyLoadProps> = ({ offset = 0, onLoad, renderLoaded, renderEmpty }) => {
  const params = React.useRef<TParams>();

  const [status, setStatus] = React.useState<ELazyLoadStatus>(ELazyLoadStatus.Pending);

  const { ref, inView } = useInView({
    rootMargin: `${offset}px`,
    threshold: 0,
    triggerOnce: true,
  });

  React.useEffect(() => {
    (async () => {
      if (inView) {
        params.current = await onLoad();
        setStatus(ELazyLoadStatus.Loaded);
      }
    })();
  }, [inView, onLoad]);

  const renderContent = React.useCallback(() => {
    let content;

    switch (status) {
      case ELazyLoadStatus.Loaded:
        content = renderLoaded(params.current);
        break;
      case ELazyLoadStatus.Pending:
      default:
        content = renderEmpty();
    }

    return content;
  }, [status, renderLoaded, renderEmpty]);

  return <div ref={ref}>{renderContent()}</div>;
};
